import {
  IconProps,
  Star,
  SuitcaseSimple,
  FileText,
  Handshake,
  Heart,
  MagnifyingGlass,
  SealQuestion,
  Calculator,
  Pen,
  Paperclip,
  Newspaper,
  CheckSquare,
  Key,
  CurrencyEur,
  Phone,
} from '@phosphor-icons/react';
import { BoxProps, Grid } from '@chakra-ui/react';
import { AcfIcon } from '@/types';

/*
 * Nice-to-have -component which resolvers color and Icon by type automatically. Easy to generate icons by data
 */
const supportedTypes = {
  star: Star,
  case: SuitcaseSimple,
  file: FileText,
  handshake: Handshake,
  heart: Heart,
  magnify: MagnifyingGlass,
  question_mark: SealQuestion,
  calculator: Calculator,
  pen: Pen,
  attachment: Paperclip,
  marketing: Newspaper,
  success: CheckSquare,
  key: Key,
  currency: CurrencyEur,
  phone: Phone,
};

const Fallback = () => null;

const getIcon = (type: AcfIcon) => supportedTypes[type] || Fallback;

const IconSelector = ({
  type,
  color,
  circle,
  bg,
  background,
  backgroundColor,
  width,
  height,
  size,
  ...iconProps
}: { type: AcfIcon; circle?: boolean } & Pick<
  BoxProps,
  'bg' | 'background' | 'backgroundColor'
> &
  IconProps) => {
  const SelectedIcon = getIcon(type);
  const icon = (
    <SelectedIcon
      {...(size ? { size } : { width, height })}
      {...iconProps}
      color={
        color
          ? `var(--chakra-colors-${color?.replace('.', '-')})`
          : 'currentColor'
      }
    />
  );

  if (circle) {
    return (
      <Grid
        {...{ bg, background, backgroundColor }}
        borderRadius="50%"
        alignItems="center"
        justifyItems="center"
        width={width || size ? `calc(${(size || width) as string} * 2)` : '2em'}
        height={
          height || size ? `calc(${(size || height) as string} * 2)` : '2em'
        }
      >
        {icon}
      </Grid>
    );
  }

  return icon;
};

export default IconSelector;
